export default "/images/logo.svg"